import { Helmet } from "react-helmet-async";

const SITE_NAME = "SCI MAYEDO";
const DOMAIN   = "https://mayedo.ci";
const DEFAULT_IMG = `${DOMAIN}/images/27.png`;

export default function SEO({
  title,
  description,
  canonical,
  image,
  type = "website",
  noindex = false,
  structuredData = null,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Immobilier en Côte d'Ivoire`;
  const desc = description ||
    "SCI MAYEDO — Vente, location et gestion de biens immobiliers de prestige en Côte d'Ivoire. Villas, appartements, bureaux à Abidjan et dans tout le pays.";
  const url  = canonical ? `${DOMAIN}${canonical}` : DOMAIN;
  const img  = image || DEFAULT_IMG;

  return (
    <Helmet>
      {/* Basiques */}
      <html lang="fr" />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type"        content={type} />
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url"         content={url} />
      <meta property="og:image"       content={img} />
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:locale"      content="fr_CI" />

      {/* Twitter Card */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image"       content={img} />

      {/* JSON-LD */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
